function a(s, c, i, n) {
  return s[c] = Object.assign(s[c] ?? {}, i, n), s[c];
}
export {
  a as assignNamespace
};
/*                                       */
